import { render } from "./TheCommissionCreateButton.vue?vue&type=template&id=a15ecf7c&ts=true"
import script from "./TheCommissionCreateButton.vue?vue&type=script&lang=ts"
export * from "./TheCommissionCreateButton.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__